module.exports = __webpack_public_path__ + "static/img/Tom-Mitchell.5477be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Mitchell.jpg
// module id = wZSa
// module chunks = 0